import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createContext, useCallback, useContext, useEffect } from 'react';
import useConstant from 'use-constant';
import create from 'zustand';
import { range } from '../../utils';
export var CollapsibleRowsContext = /*#__PURE__*/createContext(null);
export function useCollapsibleRowsStore(selector) {
  var _useContext = useContext(CollapsibleRowsContext),
      useStore = _useContext.useStore;

  return useStore(selector);
}
export function useSubRowOpen(index) {
  return useCollapsibleRowsStore(useCallback(function (state) {
    return state.allSubRowsOpen || state.openSubRows.indexOf(index) > -1;
  }, [index]));
}
export function useAnySubRowsOpen() {
  return useCollapsibleRowsStore(useCallback(function (state) {
    return state.openSubRows.length > 0;
  }, []));
}
export function useCollapsibleRows(data, defaultAllSubRowsOpen) {
  if (defaultAllSubRowsOpen === void 0) {
    defaultAllSubRowsOpen = false;
  }

  var useStore = useConstant(function () {
    return create(function (set) {
      return {
        instant: false,
        allSubRowsOpen: defaultAllSubRowsOpen,
        openSubRows: [],
        rowCountRange: [],
        callbacks: {
          openAllSubRows: function openAllSubRows() {
            set(function (state) {
              return {
                instant: true,
                allSubRowsOpen: true,
                openSubRows: state.rowCountRange
              };
            });
          },
          closeAllSubRows: function closeAllSubRows() {
            set({
              instant: true,
              allSubRowsOpen: false,
              openSubRows: []
            });
          },
          toggleAllSubRows: function toggleAllSubRows() {
            set(function (state) {
              var nextAllSubRowsOpen = state.openSubRows.length === 0;
              return {
                instant: true,
                allSubRowsOpen: nextAllSubRowsOpen,
                openSubRows: nextAllSubRowsOpen ? state.rowCountRange : []
              };
            });
          },
          toggleSubRowAtIndex: function toggleSubRowAtIndex(index) {
            set(function (state) {
              var nextOpenSubRows = [].concat(state.openSubRows);
              var currentIndex = state.openSubRows.indexOf(index);

              if (currentIndex > -1) {
                nextOpenSubRows.splice(currentIndex, 1);
              } else {
                nextOpenSubRows.push(index);
              }

              return {
                instant: false,
                allSubRowsOpen: state.rowCountRange.every(function (index) {
                  return nextOpenSubRows.indexOf(index) > -1;
                }),
                openSubRows: nextOpenSubRows
              };
            });
          }
        }
      };
    });
  });
  var callbacks = useStore(function (state) {
    return state.callbacks;
  });
  useEffect(function () {
    var rowCountRange = range(0, data.length);
    useStore.setState(function (state) {
      return {
        instant: true,
        openSubRows: state.allSubRowsOpen ? rowCountRange : [],
        rowCountRange: rowCountRange
      };
    });
  }, [data]);
  return _objectSpread({
    useStore: useStore
  }, callbacks);
}